import DestinationEntity from '../entities/Destination.Entity';
import { apiGet } from '../support/helpers/ApiConnection.Helper';

export default function getDestinations(abortSignal: AbortSignal): Promise<Array<DestinationEntity>> {
    return apiGet<Array<DestinationEntity>>('/destination', abortSignal);
}
